module.exports = __webpack_public_path__ + "static/media/chess.ab30f967.png";